import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'

import { BottomSheet, BottomSheetRef } from 'react-spring-bottom-sheet'

import 'react-spring-bottom-sheet/dist/style.css'


const Title = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 125%;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.1px;
    color: #FFFFFF;
`

const OptionButtonDiv = styled.div`
    width: 326px;
    height: 53px;
    left: 20px;
    top: 135px;
    background: #141624;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const OptionButtonTextSpan = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
`;

//Check for outside click
const useOutsideAlerter = (ref:any, callback:any) => {
    React.useEffect(() => {
        function handleClickOutside(event:any) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

export default function SeedPhraseWarningComponent(props:any) {
    const sheetRef:any = useRef<BottomSheetRef>()
    
    useEffect(() => {
        //sheetRef.current.open()
        console.log("SeedPhraseWarningComponent")
    }, [props.showWarning])
    
    function onDismiss() {
        props.setShowWarning(false)
    }

    const wrapperRef = React.useRef(null);
    
    useOutsideAlerter(wrapperRef, ()=>{
        props.setShowWarning(false)
    });

    const lolLoser = () => {
        props.setShowWarning(false);
        props.setShowLoser(true);
    }

    const okBro = () => {        
        props.copySeedPhrase(true);
        props.setShowWarning(false);
        //props.setShowSeedPhrase(false;)
        props.setShowSeed(false);
    }
    
    return (
        <BottomSheet
            open={props.showWarning}
            onDismiss={onDismiss}
        >
          <div ref={wrapperRef} style={{
              background: '#0E0F18',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: 'auto',
              zIndex: 999999,
          }}>
            <Title style={{marginTop:32}}>
              Why do you want to copy
              seed phrase?
            </Title>
            <OptionButtonDiv style={{marginTop:32}} onClick={lolLoser}>
              <OptionButtonTextSpan>
                Some person is asking for it
              </OptionButtonTextSpan>
            </OptionButtonDiv>
            <OptionButtonDiv style={{marginTop:8}} onClick={lolLoser}>
              <OptionButtonTextSpan>
                Some app is asking for it
              </OptionButtonTextSpan>
            </OptionButtonDiv>
            <OptionButtonDiv style={
            {marginTop:8, marginBottom: 32,}} onClick={okBro}>
              <OptionButtonTextSpan>
                I want to export my wallet
              </OptionButtonTextSpan>
            </OptionButtonDiv>
          </div>
        </BottomSheet>
    )
}

